import React from 'react';
import { Link } from 'react-router-dom';

const SoftwareDevelopment = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <p>Our Services</p>
            <h2>Bespoke Software Development</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-md-6">
        <div>
          <h4><b>We build Simple but Powerful Customized Products for Startups and Enterprises…</b></h4>
          <br />
          <p>We translate your ideas and requirements into rich technology solutions on a variety of technology platforms. Techarabiya master agile development capabilities help you create innovative, engaging products, while simultaneously ensuring rapid time to market. <br /><br />
            Techarabiya major strength is the ability to provide high quality services quickly with sustainable savings over the lifecycle of software products.  	
          </p>
          <br />
          <h5><b>What we offer :</b></h5>
          <ul className="list-check list-unstyled">
            <li><i className="far fa-check-circle" />Fast, reliable full product development.</li>
            <li> <i className="far fa-check-circle" />Custom application development to match your needs.</li>
            <li><i className="far fa-check-circle" />Mobile integration to rock the mobile world.</li>
            <li><i className="far fa-check-circle" />Reduced time to market = increased ROI.</li>
          </ul>
        </div>
      </div>
      <div className="col-sm-12 col-md-6">
        <img src="img/software-development.png" className="img-fluid service-image" />
      </div>
    </div>
  </div>
  <div>
    <hr />
  </div>
  <div className="container">
    <div className="text-center">
      <div className="col-12 hr-style">
        <br />
        <h2><b>Services We Offer</b></h2>
        <hr />
        <br />
      </div>
    </div>
  </div>
  {/*==========================
Services Section
    ============================*/}
  <section id="services">
    <div className="container">
      <div className="row mb-5">
        <div className="col-lg-6">
          <div className="box wow fadeInLeft">
            <div className="icon"><img className="icon" src="./img/004-coding.png" /></div>
            <h4 className="title">Software Consulting</h4>
            <p className="description">•  Technical Consultation<br />
              •  Technology Adaptation<br />
              •  RFP Development<br />
              •  Technology Strategy Development</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/006-magic-wand.png" /></div>
            <h4 className="title">Deployment</h4>
            <p className="description">•  Google Cloud<br />
              •  Microsoft Azure<br />
              •  IBM<br />
              •  AWS</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/007-graphic-design.png" /></div>
            <h4 className="title">Virtual Design &amp; Technical Assistance</h4>
            <p className="description">•  Graphic Design<br />
              •  Marvel Prototype<br />
              •  Flow Diagram</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/maintenance.png" /></div>
            <h4 className="title">Repair &amp; Maintenance</h4>
            <p className="description">•  Upgrading &amp; Updating<br />
              •  Technical Support &amp; Operational Repairing<br />
              •  Web Server Monitoring<br />
              •  Beta Testing for Google/Apple<br />
            </p></div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/011-programming.png" /></div>
            <h4 className="title">Front End &amp; Back End Development</h4>
            <p className="description">•  iOS <br />
              •  Web Apps <br />
              •  Angular JS <br />
              •  Windows <br />
              •  Android <br />
              •  PHP <br />
              •  .NET <br />
              •  Blockchain <br />
              •  Micro services <br />
              •  Node JS </p>
          </div>
        </div>
        <div className="col-lg-6">
        </div>
      </div>
    </div></section>{/* #services */}
  {/*- Contact Us bar */}
  <div className="container contactus">
  <div className="row mb-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
        
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
</div>

            
        </div>
    )
}

export default SoftwareDevelopment
